import { createSelector } from 'reselect';
import { Tier } from 'features/premium/entities';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import checkFeatureFlag from 'utils/featureFlags';
export const isOnboardingReportEnabled = (featureFlags) => checkFeatureFlag(featureFlags, 'ab_onboarding_report');
export const isOnboardingSetupEnabled = (featureFlags) => checkFeatureFlag(featureFlags, 'ab_onboarding_setup') ||
    isOnboardingReportEnabled(featureFlags);
/** The variant drops the subscriptions step, so the labels read N/2. */
export const getSetupStepCount = (featureFlags) => isOnboardingReportEnabled(featureFlags) ? 2 : 3;
export const isEligibleForOnboardingSetup = ({ user, signInNavigation, }) => !signInNavigation.isSigningIn &&
    user.guessedHomeCountry === 'GB' &&
    !!user.emmaProStatus?.active &&
    user.emmaProStatus?.tier !== Tier.free;
export const selectSetupStepCount = createSelector([(store) => store.utils.featureFlags], getSetupStepCount);
export const selectShouldEnterOnboardingReport = (store) => isOnboardingReportEnabled(store.utils.featureFlags) &&
    isEligibleForOnboardingSetup({
        user: store.user.user,
        signInNavigation: store.signInNavigation,
    });
export const selectShouldForceOnboardingReport = (store) => store.deviceSettings.onboardingReportStatus === 'pending';
export const initOnboardingReportStatus = (isInTest) => setDeviceSettingsKey('onboardingReportStatus', isInTest ? 'pending' : undefined);
export const markOnboardingReportSeen = () => setDeviceSettingsKey('onboardingReportStatus', 'seen');
